// extracted by mini-css-extract-plugin
export default {"archiveBtn":"ArchiveButton_archiveBtn__E8uR1"};